<template>
  <div class="login-form">
    <div class="card card--transparent login-card">
      <div class="card card--container">
        <form @submit="save">
          <h-input required label="New Password" v-model="password" type="password" />
          <h-input
            required
            label="Confirm Password"
            v-model="confirmation"
            :rules="confirmationError" 
            type="password" />
          <div class="error-msg" v-if="error">{{error}}</div>
          <h-btn :disabled="saving" class="full-width small-top" style="margin: 20px 0px 0px" color="primary" type="submit">Save</h-btn>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import dataStore from "@/services/api/store";
import AuthUser from "@/services/api/authUser";
import snackbar from "@/services/hubs/snackbar";


export default {
  data() {
    return {
      saving: false,
      password: "",
      confirmation: "",
      error: '',
      confirmationError: [
        () => this.confirmation === this.password || "Does not match"
      ]
    };
  },
  methods: {
    save($event) {
      $event.preventDefault();
      if (!this.password || !this.confirmation) {
        this.error = "Please fill out all fields";
        return;
      } else if (this.confirmation !== this.password) {
        this.error = "Confirmation does not match";
        return;
      }

      const data = {
        password: this.password,
        confirmation: this.confirmation,
        token: this.$route.params.token
      };
      this.saving = true;
      dataStore
        .getMapper("User")
        .resetPassword({ data })
        .then((response) => {
          snackbar.update("Password updated");
          return AuthUser._login(response.data);
        })
        .then(() => {
          this.$router.push("/");
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>

<style>
.login-form {
  height: 70vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.login-card {
  width: 500px;
}
@media (max-width: 600px) {
  .login-card {
    width: 100%;
  }
}
</style>
